module.exports = __webpack_public_path__ + "static/05-8c54175c824adbf41e6c13e5a1b02e0f.jpg";